import { Button } from '@factorialco/deprecated-design-system'
import {
  CompetenciesCreateCompetencyGroupDocument,
  CompetencyGroupsDataCollectionDocument,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useForm } from 'modules/core/hooks/useForm'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

type FormData = {
  name: string
  companyId: string
}

interface Props {
  onClose: () => void
}

export const NewCompetencyGroupModal: React.FC<Props> = ({ onClose }) => {
  const { company: currentCompany } = useCurrentSession()
  const [create] = useMutation(CompetenciesCreateCompetencyGroupDocument, {
    extractorFn: (data) => data.competenciesMutations.createCompetenciesCompetencyGroup,
  })

  const form = useForm<FormData>({
    defaultValues: {
      name: '',
      companyId: currentCompany.id,
    },
    async onSubmit(values, { setErrors }) {
      const result = await create({
        variables: {
          name: values.name,
          companyId: values.companyId,
        },
        refetchQueries: [CompetencyGroupsDataCollectionDocument],
      })

      const handled = handleResult(result, (errors) => setErrors(errors))

      if (handled.success) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('competencies_v3.new_competency_group.created_successfully'),
        })

        onClose()
      }

      return handled
    },
  })

  return (
    <Modal
      title={i18n.t('competencies_v3.new_competency_group.title')}
      description={i18n.t('competencies_v3.new_competency_group.description')}
      illustration="new-folder"
      onClose={onClose}
      onSubmit={() => form.handleSubmit()}
      footer={
        <Button disabled={form.isSubmitting} submit>
          {i18n.t('common.create')}
        </Button>
      }
    >
      <TextField
        label={i18n.t('competencies_v3.new_competency_group.name_label')}
        value={form.values.name}
        onChange={(value) => form.setFieldValue('name', value)}
        error={form.errors.name}
        mandatory
      />
    </Modal>
  )
}
